/**
 * Top level page navigation (as opposed to a react router based nav) with logging.
 * This should be the only place in gatekeeper that sets window.location.href.
 *
 * The auth flow is complex and there's potential to have too many redirects
 * or get stuck in a loop, so we log all top level navigations to help debug
 * any issues.
 */
export function navigateToUrl(
  url: string,
  opts?: { replace?: boolean; reason?: string; error?: Error | string | unknown }
) {
  const currentUrl = window.location.href;
  const logStr = `Top level navigation from ${currentUrl} to ${url}.`;
  console.log(logStr, opts?.reason);

  // This can be really high-volume, disabling temporarily
  // if (opts?.error) {
  //   sentry.error({
  //     error: opts.error,
  //     topic: 'auth',
  //     addContext: {
  //       name: 'navigateToUrl',
  //       context: {
  //         currentUrl,
  //         nextUrl: url,
  //         navigationDetails: opts?.reason,
  //       },
  //     },
  //   });
  // }

  if (opts?.replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
}
